import React, { useState } from 'react';
import { KeenIcon } from '@/components';
import { AvatarUpload, InputForm, IntroImage, AgentAdvancedSettings, ActionButton } from './builder-form';

const AgentBuilder = ({ onFormChange, initialData, colors, onColorChange, onSave, hasChanges }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);

  return (
    <div className="space-y-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex items-center justify-between py-2 px-4 border border-black border-opacity-50 
          ${isOpen ? 'bg-gray-300' : 'bg-white'} rounded-md hover:bg-gray-200 transition-colors`}
      >
        <h3 className="text-base font-bold"><KeenIcon icon="setting-4" className="mr-2"/> Agent Builder</h3>
        <span className="text-gray-500">
          {isOpen ? <KeenIcon icon="down" /> : <KeenIcon icon="right" />}
        </span>
      </button>
      
      {isOpen && (
        <div className="space-y-2 p-4 border rounded-lg">
          {showAdvanced ? (
            <AgentAdvancedSettings 
              onBack={() => setShowAdvanced(false)} 
              fill={colors.fill}
              stroke={colors.stroke}
              onChange={onColorChange}
            />
          ) : (
            <>
              <AvatarUpload />
              <InputForm onFormChange={onFormChange} initialData={initialData} />
              <IntroImage />
              <div className="flex justify-center gap-2">
                <ActionButton />
                <button onClick={() => setShowAdvanced(true)} className='w-full border rounded px-3 py-1 flex items-center gap-1'>
                  <KeenIcon icon="setting-4" className="mr-1" /> Advanced Settings
                </button>
              </div>
              <button 
                onClick={onSave}
                className={`w-full text-white py-2 rounded mt-4 font-bold flex items-center justify-center gap-2 ${
                  hasChanges ? 'bg-[#00B14F]' : 'bg-gray-400'
                }`}
              >
                <KeenIcon icon="save-2" />
                {hasChanges ? 'Save Changes' : 'Saved'}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export { AgentBuilder };
